import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const LeakageChart = ({ noShowCurrent = 0, noShowPrevious = 0, cancellationCurrent = 0, cancellationPrevious = 0, currency = "AED" }) => {
  const data = [
    { period: "This Period",     "No-Show Loss": noShowCurrent,    "Cancellation Loss": cancellationCurrent },
    { period: "Previous Period", "No-Show Loss": noShowPrevious,   "Cancellation Loss": cancellationPrevious },
  ];

  const hasData = noShowCurrent > 0 || cancellationCurrent > 0 || noShowPrevious > 0 || cancellationPrevious > 0;
  if (!hasData) return (
    <div style={{ padding: "32px", textAlign: "center", color: "#9CA3AF", fontSize: "14px" }}>No loss data available</div>
  );

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} barGap={6} barSize={40}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
        <XAxis dataKey="period" tick={{ fill: "#6B7280", fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis
          tickFormatter={v => `${currency} ${(v / 1000).toFixed(1)}k`}
          tick={{ fill: "#6B7280", fontSize: 11 }} axisLine={false} tickLine={false}
        />
        <Tooltip
          formatter={v => [`${currency} ${Number(v).toLocaleString()}`, ""]}
          contentStyle={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", fontSize: "12px" }}
        />
        <Legend wrapperStyle={{ fontSize: "12px", color: "#6B7280" }} />
        <Bar dataKey="No-Show Loss"      fill="#F59E0B" stackId="a" isAnimationActive animationDuration={600} />
        <Bar dataKey="Cancellation Loss" fill="#DC2626" stackId="a" radius={[4, 4, 0, 0]} isAnimationActive animationDuration={600} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default LeakageChart;
